/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { conversationCommandTypeFromJSON, conversationCommandTypeToJSON, } from "./conversation";
import { StringValue } from "./google/protobuf/wrappers";
export var ComponentButtonAdditionalDataKey;
(function (ComponentButtonAdditionalDataKey) {
    ComponentButtonAdditionalDataKey[ComponentButtonAdditionalDataKey["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ComponentButtonAdditionalDataKey[ComponentButtonAdditionalDataKey["NEW_INTENT"] = 1] = "NEW_INTENT";
    ComponentButtonAdditionalDataKey[ComponentButtonAdditionalDataKey["PROCEED_MESSAGE"] = 2] = "PROCEED_MESSAGE";
})(ComponentButtonAdditionalDataKey || (ComponentButtonAdditionalDataKey = {}));
export function componentButtonAdditionalDataKeyFromJSON(object) {
    switch (object) {
        case 0:
        case "COMPONENT_BUTTON_ADDITIONAL_DATA_KEY_UNSPECIFIED":
            return ComponentButtonAdditionalDataKey.UNSPECIFIED;
        case 1:
        case "COMPONENT_BUTTON_ADDITIONAL_DATA_KEY_NEW_INTENT":
            return ComponentButtonAdditionalDataKey.NEW_INTENT;
        case 2:
        case "COMPONENT_BUTTON_ADDITIONAL_DATA_KEY_PROCEED_MESSAGE":
            return ComponentButtonAdditionalDataKey.PROCEED_MESSAGE;
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ComponentButtonAdditionalDataKey");
    }
}
export function componentButtonAdditionalDataKeyToJSON(object) {
    switch (object) {
        case ComponentButtonAdditionalDataKey.UNSPECIFIED:
            return "COMPONENT_BUTTON_ADDITIONAL_DATA_KEY_UNSPECIFIED";
        case ComponentButtonAdditionalDataKey.NEW_INTENT:
            return "COMPONENT_BUTTON_ADDITIONAL_DATA_KEY_NEW_INTENT";
        case ComponentButtonAdditionalDataKey.PROCEED_MESSAGE:
            return "COMPONENT_BUTTON_ADDITIONAL_DATA_KEY_PROCEED_MESSAGE";
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ComponentButtonAdditionalDataKey");
    }
}
function createBaseComponentButtonAdditionalDataMapEntry() {
    return { key: 0, value: "" };
}
export const ComponentButtonAdditionalDataMapEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== 0) {
            writer.uint32(8).int32(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentButtonAdditionalDataMapEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 8) {
                        break;
                    }
                    message.key = reader.int32();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? componentButtonAdditionalDataKeyFromJSON(object.key) : 0,
            value: isSet(object.value) ? String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = componentButtonAdditionalDataKeyToJSON(message.key));
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    create(base) {
        return ComponentButtonAdditionalDataMapEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentButtonAdditionalDataMapEntry();
        message.key = object.key ?? 0;
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseComponentButton() {
    return { text: "", additionalData: [], conversationCommand: 0 };
}
export const ComponentButton = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        for (const v of message.additionalData) {
            ComponentButtonAdditionalDataMapEntry.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.conversationCommand !== 0) {
            writer.uint32(24).int32(message.conversationCommand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentButton();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.additionalData.push(ComponentButtonAdditionalDataMapEntry.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag != 24) {
                        break;
                    }
                    message.conversationCommand = reader.int32();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? String(object.text) : "",
            additionalData: Array.isArray(object?.additionalData)
                ? object.additionalData.map((e) => ComponentButtonAdditionalDataMapEntry.fromJSON(e))
                : [],
            conversationCommand: isSet(object.conversationCommand)
                ? conversationCommandTypeFromJSON(object.conversationCommand)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        message.text !== undefined && (obj.text = message.text);
        if (message.additionalData) {
            obj.additionalData = message.additionalData.map((e) => e ? ComponentButtonAdditionalDataMapEntry.toJSON(e) : undefined);
        }
        else {
            obj.additionalData = [];
        }
        message.conversationCommand !== undefined &&
            (obj.conversationCommand = conversationCommandTypeToJSON(message.conversationCommand));
        return obj;
    },
    create(base) {
        return ComponentButton.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentButton();
        message.text = object.text ?? "";
        message.additionalData = object.additionalData?.map((e) => ComponentButtonAdditionalDataMapEntry.fromPartial(e)) ||
            [];
        message.conversationCommand = object.conversationCommand ?? 0;
        return message;
    },
};
function createBaseComponentButtonGroup() {
    return { items: [], isBlocking: false, slotId: undefined };
}
export const ComponentButtonGroup = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.items) {
            ComponentButton.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.isBlocking === true) {
            writer.uint32(16).bool(message.isBlocking);
        }
        if (message.slotId !== undefined) {
            StringValue.encode({ value: message.slotId }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentButtonGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.items.push(ComponentButton.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag != 16) {
                        break;
                    }
                    message.isBlocking = reader.bool();
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.slotId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            items: Array.isArray(object?.items) ? object.items.map((e) => ComponentButton.fromJSON(e)) : [],
            isBlocking: isSet(object.isBlocking) ? Boolean(object.isBlocking) : false,
            slotId: isSet(object.slotId) ? String(object.slotId) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.items) {
            obj.items = message.items.map((e) => e ? ComponentButton.toJSON(e) : undefined);
        }
        else {
            obj.items = [];
        }
        message.isBlocking !== undefined && (obj.isBlocking = message.isBlocking);
        message.slotId !== undefined && (obj.slotId = message.slotId);
        return obj;
    },
    create(base) {
        return ComponentButtonGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentButtonGroup();
        message.items = object.items?.map((e) => ComponentButton.fromPartial(e)) || [];
        message.isBlocking = object.isBlocking ?? false;
        message.slotId = object.slotId ?? undefined;
        return message;
    },
};
function createBaseComponentDropdown() {
    return { text: "" };
}
export const ComponentDropdown = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentDropdown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { text: isSet(object.text) ? String(object.text) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.text !== undefined && (obj.text = message.text);
        return obj;
    },
    create(base) {
        return ComponentDropdown.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentDropdown();
        message.text = object.text ?? "";
        return message;
    },
};
function createBaseComponentDropdownGroup() {
    return { items: [], isBlocking: false, slotId: undefined };
}
export const ComponentDropdownGroup = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.items) {
            ComponentDropdown.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.isBlocking === true) {
            writer.uint32(16).bool(message.isBlocking);
        }
        if (message.slotId !== undefined) {
            StringValue.encode({ value: message.slotId }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentDropdownGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.items.push(ComponentDropdown.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag != 16) {
                        break;
                    }
                    message.isBlocking = reader.bool();
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.slotId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            items: Array.isArray(object?.items) ? object.items.map((e) => ComponentDropdown.fromJSON(e)) : [],
            isBlocking: isSet(object.isBlocking) ? Boolean(object.isBlocking) : false,
            slotId: isSet(object.slotId) ? String(object.slotId) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.items) {
            obj.items = message.items.map((e) => e ? ComponentDropdown.toJSON(e) : undefined);
        }
        else {
            obj.items = [];
        }
        message.isBlocking !== undefined && (obj.isBlocking = message.isBlocking);
        message.slotId !== undefined && (obj.slotId = message.slotId);
        return obj;
    },
    create(base) {
        return ComponentDropdownGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentDropdownGroup();
        message.items = object.items?.map((e) => ComponentDropdown.fromPartial(e)) || [];
        message.isBlocking = object.isBlocking ?? false;
        message.slotId = object.slotId ?? undefined;
        return message;
    },
};
function createBaseComponentImage() {
    return { url: "", alt: undefined };
}
export const ComponentImage = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.alt !== undefined) {
            StringValue.encode({ value: message.alt }, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentImage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.alt = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? String(object.url) : "",
            alt: isSet(object.alt) ? String(object.alt) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.url !== undefined && (obj.url = message.url);
        message.alt !== undefined && (obj.alt = message.alt);
        return obj;
    },
    create(base) {
        return ComponentImage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentImage();
        message.url = object.url ?? "";
        message.alt = object.alt ?? undefined;
        return message;
    },
};
function createBaseComponentLink() {
    return { url: "", text: "" };
}
export const ComponentLink = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentLink();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { url: isSet(object.url) ? String(object.url) : "", text: isSet(object.text) ? String(object.text) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.url !== undefined && (obj.url = message.url);
        message.text !== undefined && (obj.text = message.text);
        return obj;
    },
    create(base) {
        return ComponentLink.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentLink();
        message.url = object.url ?? "";
        message.text = object.text ?? "";
        return message;
    },
};
function createBaseComponentMarkdown() {
    return { text: "" };
}
export const ComponentMarkdown = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentMarkdown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { text: isSet(object.text) ? String(object.text) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.text !== undefined && (obj.text = message.text);
        return obj;
    },
    create(base) {
        return ComponentMarkdown.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentMarkdown();
        message.text = object.text ?? "";
        return message;
    },
};
function createBaseComponentText() {
    return { text: "" };
}
export const ComponentText = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponentText();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { text: isSet(object.text) ? String(object.text) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.text !== undefined && (obj.text = message.text);
        return obj;
    },
    create(base) {
        return ComponentText.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponentText();
        message.text = object.text ?? "";
        return message;
    },
};
function createBaseComponent() {
    return { component: undefined };
}
export const Component = {
    encode(message, writer = _m0.Writer.create()) {
        switch (message.component?.$case) {
            case "buttonGroup":
                ComponentButtonGroup.encode(message.component.buttonGroup, writer.uint32(10).fork()).ldelim();
                break;
            case "dropdownGroup":
                ComponentDropdownGroup.encode(message.component.dropdownGroup, writer.uint32(18).fork()).ldelim();
                break;
            case "image":
                ComponentImage.encode(message.component.image, writer.uint32(26).fork()).ldelim();
                break;
            case "link":
                ComponentLink.encode(message.component.link, writer.uint32(34).fork()).ldelim();
                break;
            case "markdown":
                ComponentMarkdown.encode(message.component.markdown, writer.uint32(42).fork()).ldelim();
                break;
            case "text":
                ComponentText.encode(message.component.text, writer.uint32(50).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseComponent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag != 10) {
                        break;
                    }
                    message.component = {
                        $case: "buttonGroup",
                        buttonGroup: ComponentButtonGroup.decode(reader, reader.uint32()),
                    };
                    continue;
                case 2:
                    if (tag != 18) {
                        break;
                    }
                    message.component = {
                        $case: "dropdownGroup",
                        dropdownGroup: ComponentDropdownGroup.decode(reader, reader.uint32()),
                    };
                    continue;
                case 3:
                    if (tag != 26) {
                        break;
                    }
                    message.component = { $case: "image", image: ComponentImage.decode(reader, reader.uint32()) };
                    continue;
                case 4:
                    if (tag != 34) {
                        break;
                    }
                    message.component = { $case: "link", link: ComponentLink.decode(reader, reader.uint32()) };
                    continue;
                case 5:
                    if (tag != 42) {
                        break;
                    }
                    message.component = { $case: "markdown", markdown: ComponentMarkdown.decode(reader, reader.uint32()) };
                    continue;
                case 6:
                    if (tag != 50) {
                        break;
                    }
                    message.component = { $case: "text", text: ComponentText.decode(reader, reader.uint32()) };
                    continue;
            }
            if ((tag & 7) == 4 || tag == 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            component: isSet(object.buttonGroup)
                ? { $case: "buttonGroup", buttonGroup: ComponentButtonGroup.fromJSON(object.buttonGroup) }
                : isSet(object.dropdownGroup)
                    ? { $case: "dropdownGroup", dropdownGroup: ComponentDropdownGroup.fromJSON(object.dropdownGroup) }
                    : isSet(object.image)
                        ? { $case: "image", image: ComponentImage.fromJSON(object.image) }
                        : isSet(object.link)
                            ? { $case: "link", link: ComponentLink.fromJSON(object.link) }
                            : isSet(object.markdown)
                                ? { $case: "markdown", markdown: ComponentMarkdown.fromJSON(object.markdown) }
                                : isSet(object.text)
                                    ? { $case: "text", text: ComponentText.fromJSON(object.text) }
                                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.component?.$case === "buttonGroup" && (obj.buttonGroup = message.component?.buttonGroup
            ? ComponentButtonGroup.toJSON(message.component?.buttonGroup)
            : undefined);
        message.component?.$case === "dropdownGroup" && (obj.dropdownGroup = message.component?.dropdownGroup
            ? ComponentDropdownGroup.toJSON(message.component?.dropdownGroup)
            : undefined);
        message.component?.$case === "image" &&
            (obj.image = message.component?.image ? ComponentImage.toJSON(message.component?.image) : undefined);
        message.component?.$case === "link" &&
            (obj.link = message.component?.link ? ComponentLink.toJSON(message.component?.link) : undefined);
        message.component?.$case === "markdown" &&
            (obj.markdown = message.component?.markdown ? ComponentMarkdown.toJSON(message.component?.markdown) : undefined);
        message.component?.$case === "text" &&
            (obj.text = message.component?.text ? ComponentText.toJSON(message.component?.text) : undefined);
        return obj;
    },
    create(base) {
        return Component.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseComponent();
        if (object.component?.$case === "buttonGroup" &&
            object.component?.buttonGroup !== undefined &&
            object.component?.buttonGroup !== null) {
            message.component = {
                $case: "buttonGroup",
                buttonGroup: ComponentButtonGroup.fromPartial(object.component.buttonGroup),
            };
        }
        if (object.component?.$case === "dropdownGroup" &&
            object.component?.dropdownGroup !== undefined &&
            object.component?.dropdownGroup !== null) {
            message.component = {
                $case: "dropdownGroup",
                dropdownGroup: ComponentDropdownGroup.fromPartial(object.component.dropdownGroup),
            };
        }
        if (object.component?.$case === "image" && object.component?.image !== undefined && object.component?.image !== null) {
            message.component = { $case: "image", image: ComponentImage.fromPartial(object.component.image) };
        }
        if (object.component?.$case === "link" && object.component?.link !== undefined && object.component?.link !== null) {
            message.component = { $case: "link", link: ComponentLink.fromPartial(object.component.link) };
        }
        if (object.component?.$case === "markdown" &&
            object.component?.markdown !== undefined &&
            object.component?.markdown !== null) {
            message.component = { $case: "markdown", markdown: ComponentMarkdown.fromPartial(object.component.markdown) };
        }
        if (object.component?.$case === "text" && object.component?.text !== undefined && object.component?.text !== null) {
            message.component = { $case: "text", text: ComponentText.fromPartial(object.component.text) };
        }
        return message;
    },
};
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function isSet(value) {
    return value !== null && value !== undefined;
}
